<template>
    <div class="home">
        <calendar-task style="background-color: white;" @date-change="dateChange" @item-click="itemClick" :date="date" v-model="calendarData">
        </calendar-task>
    </div>
</template>

<script lang="js">
import calendarTask from '@/components/CalendarTask.vue';
export default {
    name: "Home",
    components: {
        calendarTask
    },
    props: {
        title: { type: String },
    },
    data: () => ({
        date: new Date(),
        calendarData: []
    }),
    created() {
    },
    methods: {
        itemClick(item) {
            console.log(item);
        },
        dateChange(date){
            this.$axios.get('/api/Calendar/GetCalendarData?start=' + this.dateFormat(date.start) + '&end=' + this.dateFormat(date.end)).then(d => {
                this.calendarData = d.data;
            });
        },
        
        /** 日期格式化 */
        dateFormat(date, fmt = "yyyy-MM-dd") {
            if (!date) return "";
            if (typeof(date) === 'string') {
                date = new Date(date.replace(/-/g, '/'));
            }
            const o = {
                "M+" : date.getMonth()+1,                 //月份
                "d+" : date.getDate(),                    //日
                "H+" : date.getHours(),                   //小时
                "m+" : date.getMinutes(),                 //分
                "s+" : date.getSeconds(),                 //秒
                "q+" : Math.floor((date.getMonth()+3)/3), //季度
                "S"  : date.getMilliseconds()             //毫秒
            };
            let _fmt = fmt;
            if(/(y+)/.test(fmt))
                _fmt = _fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            for(const k in o)
                if(new RegExp("("+ k +")").test(_fmt))
                    _fmt = _fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
            return _fmt;
        },
    }
};
</script>

<style lang="scss">
    html, body {
        background-color: #E5E5E5;
    }
    .home {
        display: inline-block;
        min-height: 700px;
        background-color: white;
        width:80%;
    }
    li[type='1']::before{
        background-color:#3011b8 !important;
    }
    li[type='2']::before{
        background-color:#8b8b8a !important;
    }
    li[type='3']::before{
        background-color:#ec5656 !important;
    }
</style>